/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Action_LabelInputs */

const en_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Transcript`)
};

const fr_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer la transcription`)
};

const de_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import-Transkript`)
};

const it_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa trascrizione`)
};

const ru_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт стенограммы`)
};

const es_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar transcripción`)
};

const zh_cn2_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入成绩单`)
};

const ja_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートトランスクリプト`)
};

const hi_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख आयात करें`)
};

const pt_pt2_plain_text_import_action_label = /** @type {(inputs: Plain_Text_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar transcrição`)
};

/**
* | output |
* | --- |
* | "Import Transcript" |
*
* @param {Plain_Text_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_action_label = /** @type {((inputs?: Plain_Text_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_action_label(inputs)
	if (locale === "de") return de_plain_text_import_action_label(inputs)
	if (locale === "it") return it_plain_text_import_action_label(inputs)
	if (locale === "ru") return ru_plain_text_import_action_label(inputs)
	if (locale === "es") return es_plain_text_import_action_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_action_label(inputs)
	if (locale === "ja") return ja_plain_text_import_action_label(inputs)
	if (locale === "hi") return hi_plain_text_import_action_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_action_label(inputs)
	return en_plain_text_import_action_label(inputs)
});